import * as T from './types';

export const mutations = {
  [T.SM_SET_UI_FLAG]($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  [T.SM_SET_SUMMARY]($state, data) {
    $state.summary = data;
  },
  [T.SM_SET_SENTIMENT]($state, data) {
    $state.sentiment = data;
  },
  [T.SM_SET_ENGAGEMENT]($state, data) {
    $state.engagement = data;
  },
  [T.SM_SET_COMPETITORS]($state, data) {
    $state.competitors = data;
  },
  [T.SM_SET_TOP_MENTIONERS]($state, data) {
    $state.topMentioners = data;
  },
  [T.SM_SET_MENTIONS]($state, data) {
    $state.mentions = data;
  },
  [T.SM_SET_PROFILES]($state, data) {
    $state.profiles = data;
  },
  [T.SM_ADD_PROFILE]($state, profile) {
    $state.profiles = [profile, ...$state.profiles];
  },
  [T.SM_UPDATE_PROFILE]($state, profile) {
    $state.profiles = $state.profiles.map(p =>
      p.id === profile.id ? profile : p
    );
  },
  [T.SM_REMOVE_PROFILE]($state, id) {
    $state.profiles = $state.profiles.filter(p => p.id !== id);
  },
  [T.SM_SET_SETTINGS]($state, data) {
    $state.settings = data;
  },
  [T.SM_SET_POLITICAL_INSIGHTS]($state, data) {
    $state.politicalInsights = data;
  },
  [T.SM_SET_PUBLIC_REACTION]($state, data) {
    $state.publicReaction = data;
  },
  [T.SM_SET_PUBLIC_REACTION_ANALYSIS]($state, data) {
    $state.publicReactionAnalysis = data;
  },
  [T.SM_SET_TOPICS]($state, data) {
    $state.topics = data;
  },
  [T.SM_SET_REPORTS]($state, data) {
    $state.reports = data;
  },
  [T.SM_SET_CURRENT_REPORT]($state, data) {
    $state.currentReport = data;
  },
  [T.SM_SET_CLUSTERS]($state, data) {
    $state.clusters = data;
  },
  [T.SM_SET_ALERTS]($state, items) {
    $state.alerts = items;
  },
  [T.SM_SET_ALERT_UNREAD]($state, count) {
    $state.alertsUnreadCount = count;
  },
  [T.SM_MARK_ALERT_ACK]($state, id) {
    $state.alerts = $state.alerts.map(a =>
      a.id === id ? { ...a, acknowledgedAt: new Date().toISOString() } : a
    );
  },
  [T.SM_SET_CONTENT_BREAKDOWN]($state, data) {
    $state.contentBreakdown = data;
  },
  [T.SM_SET_CONVERSION_INDICES]($state, data) {
    $state.conversionIndices = data;
  },
  [T.SM_SET_NARRATIVES]($state, data) {
    $state.narratives = data;
  },
  [T.SM_SET_EMOTION_BREAKDOWN]($state, data) {
    $state.emotionBreakdown = data;
  },
  [T.SM_SET_CONTENT_SUGGESTIONS]($state, data) {
    $state.contentSuggestions = data;
  },
  [T.SM_SET_RESPONSE_LIBRARY]($state, data) {
    $state.responseLibrary = data;
  },
  [T.SM_SET_COPILOT]($state, data) {
    $state.copilot = data;
  },
  [T.SM_SET_TERRITORIAL_BREAKDOWN]($state, data) {
    $state.territorialBreakdown = data;
  },
  [T.SM_SET_DEMOGRAPHIC_BREAKDOWN]($state, data) {
    $state.demographicBreakdown = data;
  },
  [T.SM_SET_TERRITORIAL_SEGMENTATION]($state, data) {
    $state.territorialSegmentation = data;
  },
};
